// src/pages/admin/TransactionsList.js
import React from 'react';
import { Card, List, Typography } from 'antd';

const { Text } = Typography;

const TransactionsList = ({ transactions }) => (
  <Card title="Recent Transactions" bordered={false} style={{ marginBottom: 16 }}>
    <List
      dataSource={transactions.slice(0, 5)}
      renderItem={(item) => (
        <List.Item>
          <Text>{`${item.type}: $${item.amount} on ${item.date}`}</Text>
        </List.Item>
      )}
    />
  </Card>
);

export default TransactionsList;